var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickActionDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 22,
    fill: "#EFF1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.4C19.5 22.17 20.1 22.8 20.83 22.8H22.33C22.97 22.8 23.49 22.25 23.49 21.58C23.49 20.85 23.17 20.59 22.7 20.42L20.3 19.58C19.82 19.41 19.5 19.15 19.5 18.42C19.5 17.75 20.02 17.2 20.66 17.2H22.16C22.9 17.21 23.5 17.83 23.5 18.6",
    stroke: "#23252F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.85V23.59",
    stroke: "#23252F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.41V17.19",
    stroke: "#23252F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.49 27.98C25.9028 27.98 29.48 24.4028 29.48 19.99C29.48 15.5772 25.9028 12 21.49 12C17.0772 12 13.5 15.5772 13.5 19.99C13.5 24.4028 17.0772 27.98 21.49 27.98Z",
    stroke: "#23252F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.48 29.88C25.38 31.15 26.85 31.98 28.53 31.98C31.26 31.98 33.48 29.76 33.48 27.03C33.48 25.37 32.66 23.9 31.41 23",
    stroke: "#23252F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickActionDollar);
export default __webpack_public_path__ + "static/media/quickActionDollar.d0f94797627272d6cc63fcd47d47ac6f.svg";
export { ForwardRef as ReactComponent };